<template>
<div class="drop_list_container">
    <div
      v-for="(item, index) in dropList"
      :key="index"
      class="drop_list_item"
      @click="clickItem(item)"
    >
      <div class="enter">
        <svg-icon icon-class="file-enter" />
      </div>
      <div class="icon">
        <svg-icon icon-class="file-path" />
      </div>
      <div class="title">{{ item.fileName }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BreadCrumbDropList",
  props: {
    dropList: {
      type: Array,
      default: [],
    },
  },
  emits: ["clickItem"],
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    clickItem(item) {
      this.$emit("clickItem", item);
    },
  },
};
</script>

<style lang="scss">
.drop_list_container {
  width: 414px;
  padding: 4px;

  .drop_list_item {
    height: 32px;
    cursor: pointer;
    display: flex;
    align-items: center;
    border-radius: 8px;

    &:hover {
      background-color: #f4f6f9;
    }

    .enter {
      flex-shrink: 0;
      width: 16px;
      height: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0px 8px;
    }
    .icon {
      flex-shrink: 0;
      width: 16px;
      height: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 8px;
    }

    .title {
      font-size: 14px;
      color: #222329;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
